export default __webpack_public_path__ + "static/media/front_cover.d9de4213.png";